module.exports = require("cloudinary-core");